<template>
  <div class="miny-100vh o-hidden authentigate-login">
    <div class="login-container">
      <div class="flex-logo">
        <img
          src="../assets/logo-for-dark-bg.svg"
          alt="AuthentiGate"
        >
        <h1>Sign in with email</h1>
      </div>

      <div class="sign-in-container">
        <auth-sign-in @signIn="redirectToSignInSuccess" />
        <div class="sign-up">
          <v-btn
            x-large
            block
            outlined
            to="/signup"
            color="primary"
          >
            Sign Up
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthSignIn from '@/components/auth/AuthSignIn.vue'
// The user might have been coming from a path deeper than /, so grab the redirect param from the url, if it exists
const urlParams = new URLSearchParams(window.location.search)
const signInSuccessUrl = urlParams.has('redirect')
  ? decodeURIComponent(urlParams.get('redirect'))
  : '/dashboard'

export default {
  name: 'Auth',
  components: { AuthSignIn },
  data: function () {
    return {}
  },
  watch: {
    email: function () {
      this.emailValid = this.$refs.email.$refs.input.validity.valid
    }
  },
  methods: {
    async redirectToSignInSuccess() {
      this.$router.push(signInSuccessUrl).catch()
    }
  }
}
</script>

<style lang="scss">
.authentigate-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url('../assets/login-bg-graphic.svg');
  background-color: var(--v-darkslategray-base);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;

  h1 {
    color: white;
    font-weight: 600;
    margin: 20px 0;
  }

  .sign-in-container {
    display: flex;
    flex-direction: column;
    background-color: white;
    min-width: 500px;
  }

  .sign-up .v-btn {
    margin-top: 15px;
    border-color: transparent;
    border-radius: 0;
    border-top: 1px solid rgb(188 188 188 / 30%);
  }
}

.flex-logo {
  flex: 0 1 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-logo img {
  max-height: 75px;
}
</style>
